import Vuex from 'vuex';

import { favourites } from './favourites';
import { cart } from './cart';
import { delivery } from './delivery';

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        isAuth: false,
        isActive: false,
        name: null,
        email: null,
        phone: null,
    },

    mutations: {
        setIsAuth: (state, payload) => {
            state.isAuth = payload.is_auth;
            state.isActive = payload.is_active;
            state.name = payload.name;
            state.email = payload.email;
            state.phone = payload.phone;
        },
    },
    actions: {
        checkAuth: async ({ commit, dispatch }) => {
            let { data } = await axios.get('/ajax/auth');

            commit('setIsAuth', data);
            // dispatch('informs/getInforms');

            if (data.is_auth) {
                dispatch('favourites/getFavourites');
            }
        },
    },
    modules: {
        favourites,
        cart,
        delivery
    },
    strict: debug,
    // plugins: debug ? [createLogger()] : []
})
